import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Package } from 'lucide-react';
import { Button } from './ui/button';

/**
 * BundleCTA — compact strip driving traffic to the feature comparison on the SAP B1 hub page.
 * Placed on key pages to surface the "everything included" message.
 *
 * Props:
 *   headline – page-specific hook line
 *   body     – one-sentence context
 *   cta      – button label
 */
const BundleCTA = ({
  headline = 'Everything included. No hidden extras.',
  body = 'Many providers charge separately for MFA, SSO, UAT environments, upgrade assistance and more. See exactly what the C4P bundle includes, and how it compares.',
  cta = 'See the full comparison',
}) => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-gradient-to-r from-emerald-50 via-white to-cyan-50 border-y border-emerald-100 overflow-hidden">
      {/* Subtle pattern */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, rgb(16 185 129) 1px, transparent 0)', backgroundSize: '40px 40px' }} />
      </div>

      <div className="container mx-auto px-4 lg:px-8 py-10 relative z-10">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 max-w-5xl mx-auto">

          {/* Icon + text */}
          <div className="flex items-start gap-5">
            {/* Icon box */}
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-600 to-cyan-700 flex items-center justify-center flex-shrink-0 shadow-lg shadow-emerald-500/20">
              <Package className="w-7 h-7 text-white" />
            </div>

            {/* Copy */}
            <div>
              <div className="text-[10px] font-bold text-emerald-600 uppercase tracking-widest mb-1">
                The C4P Bundle
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-1 leading-snug">{headline}</h3>
              <p className="text-slate-500 text-sm leading-relaxed max-w-xl">{body}</p>
            </div>
          </div>

          {/* CTA */}
          <Button
            className="bg-gradient-to-r from-emerald-600 to-cyan-700 hover:from-emerald-500 hover:to-cyan-600 text-white font-bold px-6 py-3 flex-shrink-0 shadow-md shadow-emerald-500/20"
            onClick={() => navigate('/sap-b1-cloud-hosting')}
            data-testid="bundle-cta-btn"
          >
            {cta}
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BundleCTA;
